import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';
import {PredefinedStep} from '../message/PredefinedStep';

export class PredefinedStepWrapper extends BaseWrapper<PredefinedStep, BasicCriteria, BasicScenario>  {}

